import React from 'react'
import styles from './spacer.module.scss'

export const Spacer = () => <div className={styles.Spacer}>&nbsp;</div>
